export type QRScanResult = {
  SellerGstin: string
  BuyerGstin: string
  DocNo: string
  DocTyp: string
  DocDt: string
  TotInvVal: number
  ItemCnt: number
  MainHsnCode: string
  Irn: string
  IrnDt: string
};

export const QRFieldsMap = new Map([
  ['SellerGstin', 'Supplier GSTIN'],
  ['BuyerGstin', 'Recipient GSTIN'],
  ['DocNo', 'Document No.'],
  ['DocTyp', 'Document Type'],
  ['DocDt', 'Document Date'],
  ['TotInvVal', 'Total Invoice Value'],
  ['ItemCnt', 'No. of Line Items'],
  ['MainHsnCode', 'Main HSN Code'],
  ['Irn', 'IRN'],
  ['IrnDt', 'IRN Date'],
]);
